import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { RequestMatchModal } from './RequestMatchModal';
import { useAuth } from '@/contexts/AuthContext';
import { useIsProvider } from '@/hooks/useIsProvider';
import pawIcon from '@/assets/paw-white.png';
import { useTranslation } from 'react-i18next';

interface MatchButtonProps {
  petId: string;
  petName: string;
  petSpecies?: string;
  ownerId?: string;
  className?: string;
  size?: 'sm' | 'default' | 'lg';
}

export const MatchButton = ({ 
  petId, 
  petName,
  petSpecies,
  ownerId,
  className = '',
  size = 'sm'
}: MatchButtonProps) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { user } = useAuth();
  const { data: isProvider } = useIsProvider();

  // Service Providers don't use PetMatch - hide button
  if (isProvider) {
    return null;
  }

  // No mostrar si es la propia mascota del usuario
  if (ownerId && user?.id === ownerId) {
    return null;
  }

  return (
    <>
      <Button
        onClick={() => setIsModalOpen(true)}
        size={size}
        variant="default"
        className={`
          bg-pet-green hover:bg-pet-green/90 text-white
          flex items-center gap-1 ${className}
        `}
      >
        <img 
          src={pawIcon} 
          alt="" 
          className="h-5 w-5"
        />
        {t('matching.title')}
      </Button>

      <RequestMatchModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        targetPetId={petId}
        targetPetName={petName}
        targetPetSpecies={petSpecies}
      />
    </>
  );
};
